let btnToggleArticleContentList = document.getElementById(
  'btn_toggle_article_content_list',
);
if (btnToggleArticleContentList) {
  let articleContentList = document.getElementById('article_content_list');
  btnToggleArticleContentList.addEventListener('click', () => {
    btnToggleArticleContentList.childNodes.forEach((node) => {
      if (node.nodeName.toLowerCase() === 'span') {
        node.classList.toggle('hidden');
      }
    });
    articleContentList.classList.toggle('hidden');
  });
}

const articleProgressBar = document.querySelector('.article-progress-bar');
const articleBlock = document.querySelector('.prose');
if (articleProgressBar && articleBlock) {
  const scrollProgressBar = () => {
    let scrollDistance = -articleBlock.getBoundingClientRect().top;
    let progressPercentage =
      (scrollDistance /
        (articleBlock.getBoundingClientRect().height -
          document.documentElement.clientHeight)) *
      100;

    let val = progressPercentage.toFixed(1);
    articleProgressBar.style.width = val + '%';

    if (val < 0) {
      articleProgressBar.style.width = '0%';
    }
    if (val > 100) {
      articleProgressBar.style.width = '100%';
    }
  };

  window.addEventListener('scroll', scrollProgressBar);
}
